module.exports = __webpack_public_path__ + "img/stick_activites_rando_velo.133cc698.svg";